document.addEventListener('DOMContentLoaded', function () {
    console.log('Form in assets');
    const selectElement = document.getElementById('enquiry-type');

    // Cache the NodeList of .enquiry-form-inputs elements
    const enquiryFormInputsElements = document.querySelectorAll('.enquiry-form-inputs');

    // Convert it to an array for easier manipulation and initially hide and disable each element
    const enquiryFormInputsArray = Array.from(enquiryFormInputsElements, element => {
        element.style.display = 'none'; // Hide element
        for (const input of element.querySelectorAll('input, textarea, select')) {
            input.disabled = true; // Disable input
        }
        return element;
    });

    // Store the current displayed element to minimize the DOM manipulation
    let currentDisplayedElement = null;

    function handleSelectChange(event) {
        const selectedValue = event.target.value;

        console.log('Selected value:', selectedValue);

        // Find the element that should be displayed
        const elementToShow = enquiryFormInputsArray.find(element =>
            element.getAttribute('data-form-type') === selectedValue);

        // Hide and disable the current displayed element if it's different from the new one
        if (currentDisplayedElement && currentDisplayedElement !== elementToShow) {
            currentDisplayedElement.style.display = 'none';
            currentDisplayedElement.classList.remove('active');
            for (const input of currentDisplayedElement.querySelectorAll('input, textarea, select')) {
                input.disabled = true; // Disable input
                input.style.visibility = 'hidden';
            }
        }

        // Show and enable the new element
        if (elementToShow) {
            elementToShow.style.display = 'flex';
            elementToShow.classList.add('active');
            for (const input of elementToShow.querySelectorAll('input, textarea, select')) {
                input.disabled = false; // Enable input
                input.style.visibility = 'visible';
            }
            currentDisplayedElement = elementToShow;
        }
    }

    if (selectElement) {
        selectElement.addEventListener('change', handleSelectChange);

        // Trigger the change handler to set the initial state
        handleSelectChange({ target: selectElement });
    }
});

// Cache necessary elements
const form = document.querySelector('form.main-contact-form');
const mainContactFormText = document.getElementById('main-contact-form-text');
const submitSuccess = mainContactFormText.getAttribute('data-submit-success');
const submitFailure = mainContactFormText.getAttribute('data-submit-failure');
const successMessage = document.createElement('p');
const errorMessage = document.createElement('p');

// Prepare error message style
errorMessage.style.color = 'red';
// console.log(form)
// if (form) {
//     function onSuccess(data) {
//         console.log('Success:', data);
//         // show success message
//     }
//     function onError(error) {
//         console.log('Error:', error);
//         // show error messages for form
//     }

//     formSubmission = new QfForm(
//         'contact_form',
//         window.QF.url + '/api/forms',
//         'general_enquiry',
//         onSuccess,
//         onError
//     );
// }